export default __webpack_public_path__ + "static/media/fire.284bb7ce.svg";